import React from "react";

class Images extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let imgSrc = this.props.src;
    const theClassName = this.props.className;
    const theStyle = this.props.style;

    if (imgSrc.indexOf("http") < 0) {
      imgSrc = process.env.REACT_APP_BASE_URL + "/" + imgSrc;
    }
    return (
      <img alt="" src={imgSrc} className={theClassName} style={theStyle} />
    );
  }
}

export default Images;
